class ProductGoggleTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-goggle-compact-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-goggle-compact-panel]'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab, false));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
    });
    this.closest('[data-section-type]')?.addEventListener('theme:variant:change', (event) => this.updateLenses(event.detail?.variant?.id));
  }

  activate(activeTab, moveFocus) {
    const activePanelId = activeTab.getAttribute('aria-controls');
    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });
    this.panels.forEach((panel) => { panel.hidden = panel.id !== activePanelId; });
    if (moveFocus) activeTab.focus();
  }

  onKeydown(event, currentTab) {
    const currentIndex = this.tabs.indexOf(currentTab);
    let nextIndex = currentIndex;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex !== currentIndex) { event.preventDefault(); this.activate(this.tabs[nextIndex], true); }
  }

  updateLenses(variantId) {
    if (!variantId) return;
    this.closest('[data-section-type]')?.querySelectorAll('[data-goggle-variant-lenses]').forEach((element) => {
      element.hidden = element.dataset.goggleVariantLenses !== String(variantId);
    });
  }
}

if (!customElements.get('product-goggle-tabs')) customElements.define('product-goggle-tabs', ProductGoggleTabs);

function decorateCompactGoggle() {
  document.querySelectorAll('[data-product-goggle-compact-hook]').forEach((hook) => {
    const formWrapper = hook.closest('.form__wrapper');
    if (!formWrapper || formWrapper.dataset.goggleCompactDecorated === 'true') return;
    formWrapper.dataset.goggleCompactDecorated = 'true';
    formWrapper.classList.add('product-goggle-compact__form-wrapper');

    const decorateFavorite = () => {
      const favoriteButton = formWrapper.querySelector('klaviyo-favorites-button');
      const favoriteBlock = favoriteButton?.closest('.standard__app');
      const titleBlock = formWrapper.querySelector('.product__title-and-price');
      if (!favoriteBlock || !titleBlock) return false;
      favoriteBlock.classList.add('product-goggle-compact__wishlist');
      const alignFavorite = () => {
        const top = titleBlock.offsetTop + Math.max(0, (titleBlock.offsetHeight - favoriteBlock.offsetHeight) / 2);
        favoriteBlock.style.setProperty('--compact-wishlist-top', `${top}px`);
      };
      alignFavorite();
      window.requestAnimationFrame(alignFavorite);
      return true;
    };

    if (!decorateFavorite()) {
      const observer = new MutationObserver(() => {
        if (decorateFavorite()) observer.disconnect();
      });
      observer.observe(formWrapper, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 10000);
    }
  });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorateCompactGoggle, { once: true });
else decorateCompactGoggle();
